const Google = () => {
  return <h3>Google</h3>
}

export default Google